<template>
    <section class="section">
        <div class="container  is-hidden-mobile">
            <div class="columns">
                <div class="column" v-for="brand in brands" :key="brand.id">
                    <router-link :to="'/'+ brand.slug+'-noutbuki'">
                        <div class="card">
                            <div class="card-image">
                                <figure class="image">
                                    <img :src="brand.logo" :title="'Ноутбуки и Ультрабуки ' + brand.name + ' в Ташкенте'">
                                </figure>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'
    import {API_URL} from '../../main';

    export default {
        name: "BrandTiles",
        data() {
            return {
                brands: []
            }
        },
        methods: {
            fetchBrands() {
                axios.get(API_URL + '/brand?active=true')
                    .then(response => {
                        this.brands = response.data
                    })
            }
        },
        created() {
            this.fetchBrands()
        }
    }
</script>

<style scoped>
    .card {
        height: 100%;

    }
    .card:hover {
        -webkit-transform: scale(1.02);
        -ms-transform: scale(1.02);
        transform: scale(1.03);
        transition: 0.2s linear;
        border: 0.3px solid orange;
    }
</style>
